
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 14H4V8h16v10zM6.5 16h4a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v5a.5.5 0 00.5.5zm7-4h4a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5zm0 4h2a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5z"}})])
          )
        }
      }
    